import React, { useState } from "react";
import { Tabs } from "antd";
import Heading from "../../components/Heading";
import GenerateManifest from "../GenerateManifest";
import ManifestList from "../../views/MiddleMileOperations/ManifestList/index";

function GenerateManifestTabs() {
  const [activeKey, setActiveKey] = useState("1");
  const [manifrestId, setManifrestId] = useState({});

  const changeTab = (key) => {
    setActiveKey(key);
  };

  const onClickId = (manifestId, toPremise, name) => {
    console.log(toPremise);
    setManifrestId({ manifestId, toPremise, name });
    setActiveKey("1");
  };
  return (
    <div className="p-2">
      <Heading title={"Generate Manifest"} />
      <div className="rate-card-tab-container">
        <Tabs
          activeKey={activeKey}
          onChange={changeTab}
          items={[
            {
              label: "Generate Manifest",
              key: "1",
              children: (
                <GenerateManifest
                  manifrestId={manifrestId}
                  changeTab={changeTab}
                />
              ),
            },
            {
              label: "View Manifest",
              key: "2",
              children: (
                <ManifestList onClickId={onClickId} activeKey={activeKey} />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}

export default GenerateManifestTabs;
